import React, {useState} from 'react';
import {Button, Col, Layout, Row, Select, Space} from "antd";
import {useNavigate} from "react-router-dom";
import {GlobalOutlined, LogoutOutlined} from "@ant-design/icons";
import {useMutation, useQueryClient} from "@tanstack/react-query";
import {logoutAPI} from "../../api/AuthAPI";
import UseTranslate from "../../hooks/UseTranslate";
import SessionTimer from "./SessionTimer";

const AppHeader = () => {
    const { Header } = Layout;
    const navigate = useNavigate();
    const [locale, setLocale] = useState(localStorage.getItem('locale'));
    const expiryTime = parseInt(sessionStorage.getItem('exp'));
    const queryClient = useQueryClient();
    const translate = UseTranslate();

    const langOption = [
        {value: 'en', label: 'English'},
        {value: 'ko', label: '한국어'},
        {value: 'zh', label: '中文'},
        {value: 'ru', label: 'Русский'},
        {value: 'ar', label: '‫العربية‬'},
        {value: 'mn', label: 'Монгол хэл'},
        {value: 'ja', label: '日本語'},
        {value: 'vi', label: 'Tiếng Việt'},
    ]

    const onClickLogout = () => {
        logoutMutation.mutate();
    }

    const logoutMutation = useMutation(() => logoutAPI(), {
        onSuccess: () => {
            navigate('/', {replace: true});
            queryClient.clear();
            sessionStorage.clear();
            localStorage.removeItem("viewCasePageCache");
            localStorage.removeItem('caseListQueryParams');
        },
        onError: () => {
            queryClient.clear();
            sessionStorage.clear();
            localStorage.removeItem("viewCasePageCache");
            localStorage.removeItem('caseListQueryParams');
            navigate('/', {replace: true});
        }
    })


    const onChangeLang = (value) => {
        setLocale(value)
        localStorage.setItem('locale', value);
        window.location.reload();
    }


    return (
        <Header style={{backgroundColor: 'white'}}>
            <Row justify='end'>
                <Space size='large'>
                    <Col>
                        <GlobalOutlined />
                        <Select variant='borderless' value={locale} style={{width: 120}} options={langOption} onChange={onChangeLang} />
                    </Col>
                    <Col>
                        <SessionTimer initialExpiryTimestamp={expiryTime} />
                    </Col>
                    <Col>
                        <Button shape='round' onClick={onClickLogout} icon={<LogoutOutlined />}>{translate('logout')}</Button>
                    </Col>
                </Space>
            </Row>
        </Header>
    );
};

export default AppHeader;